import Menu from 'Models/Menu';

export default [
  Menu.organizationInformation,
  Menu.createNewOrganization,
  Menu.organizationsHelp,
];
